import { createContext, useCallback, useEffect, useState } from "react";
import {
  getAllCameras,
  innerCamera,
  login,
  deleteCamera,
  editCamera,
  getAllRegions,
  registerRegion,
  deleteRegion,
  insertVideoAnuncio,
  editRegion,
  deleteImage,
  deleteVideo,
  orderRegion,
  orderCam,
  getCameraId,
  innerNewUser,
  getListAll,
  getListAllRegional,
  changeStatusUser,
  updateUser,
  getUserId,
  deleteUserId,
  listAllEstados,
  orderingUf,
} from "../services/apis/api";
import { useCookies } from "react-cookie";

import Cookies from "js-cookie";

export const ContextApi = createContext({});

export function ContextProvider({ children }) {
  const [cookies, setCookie, removeCookie] = useCookies(["surfViewToken"]);
  const [allCameras, setAllCameras] = useState([]);
  const [cameraId, setCameraId] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [allRegional, setAllRegional] = useState([]);
  const [errorApi, setErrorApi] = useState(null);
  const [isAuthorization, setisAuthorization] = useState(false);
  const [sucessInsertCamera, setSucessInsertCamera] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allRegions, setAllRegions] = useState([]);
  const [loggedUser, setLoggedUser] = useState(false);
  const [userThisId, setUserThisId] = useState();
  const [allEstadosOrdering, setAllEstadosOrdering] = useState([]);

  const token = Cookies.get("surfViewToken");
  const tokenParsed = token ? JSON.parse(token) : null;
  const tokenConfig = tokenParsed?.token;
  const config = {
    headers: { Authorization: `Bearer ${tokenConfig}` },
  };

  useEffect(() => {
    if (!token) {
      setLoggedUser(false);
    }
    if (token) {
      setLoggedUser(true);
    }
  }, []);

  async function userLogin({ email, Password }) {
    await login(email, Password)
      .then((response) => {
        if (response.data.role === "regional") {
          setCookie(
            "surfViewToken",
            {
              token: response.data.token,
              userRole: response.data.role,
              estados: response.data.regionais,
            },
            {
              path: "/",
              maxAge: 60 * 120 * 1,
            }
          );
        } else if (!response.data.role) {
          setLoading(false);
          window.alert([
            "Erro a fazer login!\nVocê não tem permissão para acessar essa página",
          ]);
        } else {
          setCookie(
            "surfViewToken",
            {
              token: response.data.token,
              userRole: response.data.role,
            },
            {
              path: "/",
              maxAge: 60 * 120 * 1,
            }
          );
        }
        setisAuthorization(true);
        if (
          response.data.role === true ||
          response?.data?.role === "regional"
        ) {
          setLoggedUser(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        window.alert(`Erro a fazer login ${err?.response?.data?.error}`);
      });
  }

  async function logOut() {
    removeCookie("surfViewToken");
    setLoggedUser(false);
    window.location.reload();
  }

  async function createCamera(body) {
    await innerCamera(body, config)
      .then((response) => {
        setSucessInsertCamera(true);
        window.alert(
          `Camera ${response.data.data.nome_camera} cadastrada com sucesso`
        );
      })
      .catch((err) => {
        let keyError = Object.keys(err?.response?.data?.message);
        console.log(err);
        window.alert(
          `erro ao cadastrar camera! \n${err?.response?.data?.message[keyError]}`
        );
      });
  }

  async function getCameras() {
    await getAllCameras(config)
      .then((response) => {
        setAllCameras(response.data.data);
      })
      .catch((err) => {
        console.log(err);
        setErrorApi(err);
        window.alert("Erro ao buscar cameras, consulte o suporte");
      });
  }

  async function getCameraForId(idCam) {
    await getCameraId(idCam, config)
      .then((response) => {
        setCameraId(response.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function deleteCam(idItem) {
    await deleteCamera(idItem, config)
      .then((response) => {
        window.alert("Camera excluida com sucesso!");
        getCameras();
        getRegions();
      })
      .catch((err) => console.log(err));
  }

  async function updateCamera(idCam, payload) {
    await editCamera(idCam, payload, config)
      .then((response) => {
        getCameras();
        window.alert(
          `Camera ${response.data.data.nome_camera} editada com sucesso!`
        );
      })
      .catch((err) => {
        console.log(err);
        window.alert(`erro ao editar camera`);
      });
  }

  async function ordernarCameras(idRegion, payload) {
    await orderCam(idRegion, payload, config)
      .then((response) => {
        getCameras();
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao ordenar camera");
      });
  }

  //regiões

  async function getRegions() {
    await getAllRegions(config)
      .then((response) => {
        setAllRegions(response.data.data);
      })
      .catch((err) => console.log(err));
  }

  async function cadastrarRegiao(body) {
    await registerRegion(body, config)
      .then((response) => {
        window.alert("Nova região cadastrada com sucesso!");
        getRegions();
      })
      .catch((err) => {
        console.log(err);
        window.alert(`Erro ao cadastrar região}`);
      });
  }

  async function deletarRegiao(idRegion) {
    await deleteRegion(idRegion, config)
      .then((response) => {
        window.alert("Região excluida com sucesso!");
        getRegions();
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao excluir região!");
      });
  }

  async function editarRegiao(idRegion, body) {
    await editRegion(idRegion, body, config)
      .then((response) => {
        window.alert("Região editada com sucesso");
        getRegions();
      })
      .catch((err) => {
        console.log(err);
        window.alert("erro ao editar região");
      });
  }

  async function ordenarRegiao(payload) {
    await orderRegion(payload, config)
      .then((response) => {
        getRegions();
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao ordenar região");
      });
  }

  //uploadVideos
  async function handleUploadVideo(id_camera, file) {
    let formData = new FormData();
    formData.append("video", file[0]);
    const options = {
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percent = Math.floor((loaded * 100) / total);
      },
    };
    console.log(formData, file[0]);
    await insertVideoAnuncio(id_camera, formData, options, {
      headers: {
        Authorization: `Bearer ${tokenConfig}`,
        "content-type": `multipart/form-data`,
      },
    })
      .then((response) => {
        window.alert("Video cadastrado com sucesso");
        getCameras();
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao cadastrar video");
      });
  }

  async function deleteVideos(idcam, idVideo) {
    await deleteVideo(idcam, idVideo, config)
      .then((response) => {
        getCameras();
        window.alert("Video excluido com sucesso");
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao excluir video");
      });
  }

  //Images
  async function deletarImagem(idCam, nameTagImage) {
    await deleteImage(idCam, nameTagImage, config)
      .then((response) => {
        getCameras();
        window.alert("Imagem excluída com sucesso");
      })
      .catch((err) => {
        window.alert("Erro ao excluír imagem");
      });
  }

  //Usuarios - regionais
  async function newUser(payload) {
    await innerNewUser(payload, config)
      .then((response) => {
        window.alert("Usuário cadastrado com sucesso");
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao cadastrar usuário");
      });
  }

  async function listAllUsers() {
    await getListAll(config)
      .then((response) => {
        setAllUsers(response.data.data);
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro buscar usuários");
      });
  }

  async function listAllRegional() {
    await getListAllRegional(config)
      .then((response) => {
        setAllRegional(response.data.data);
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro buscar regionais");
      });
  }

  async function changeNewStatusUser(idUser) {
    await changeStatusUser(idUser, config)
      .then((response) => {
        listAllUsers();
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao alterar status");
      });
  }

  async function upDateUserRegional(idUser, payload) {
    await updateUser(idUser, payload, config)
      .then((response) => {
        listAllUsers();
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao atualizar usuario");
      });
  }

  async function getUserThisId(idUser) {
    await getUserId(idUser, config)
      .then((response) => {
        setUserThisId(response.data.data);
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao buscar usuario");
      });
  }

  async function deleteUserThisId(idUser) {
    await deleteUserId(idUser, config)
      .then((response) => {
        window.alert("Usuario excluido com sucesso!");
        listAllUsers();
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao excluir usuario");
      });
  }

  async function getAllEstados() {
    await listAllEstados(config)
      .then((response) => {
        setAllEstadosOrdering(response.data.data);
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao buscar estados, ordering");
      });
  }

  async function ordenarEstados(payload) {
    await orderingUf(payload, config)
      .then((response) => {
        getAllEstados();
      })
      .catch((err) => {
        console.log(err);
        window.alert("Erro ao ordenar estados, ordering");
      });
  }

  return (
    <ContextApi.Provider
      value={{
        allCameras,
        errorApi,
        getCameras,
        deleteCam,
        userLogin,
        isAuthorization,
        cookies,
        createCamera,
        sucessInsertCamera,
        loading,
        setLoading,
        updateCamera,
        getRegions,
        allRegions,
        cadastrarRegiao,
        deletarRegiao,
        handleUploadVideo,
        editarRegiao,
        deletarImagem,
        deleteVideos,
        ordenarRegiao,
        ordernarCameras,
        loggedUser,
        getCameraForId,
        cameraId,
        newUser,
        listAllUsers,
        allUsers,
        listAllRegional,
        allRegional,
        changeNewStatusUser,
        logOut,
        upDateUserRegional,
        getUserThisId,
        userThisId,
        deleteUserThisId,
        getAllEstados,
        allEstadosOrdering,
        ordenarEstados,
      }}
    >
      {children}
    </ContextApi.Provider>
  );
}
